import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Icon from '@material-ui/core/Icon'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { toDateString, shouldShowCompliant, getCarryOverReasons, getCarryOverInfo, LBS_PER_KG } from '../../../util'
import _ from 'lodash'
import AvatarButton from '../components/avn-button'
import Transition from '../../../../../../../images/modals/check-in-transition.svg'
import IconCalendar from '../../../../../../../images/modals/iconCalendar.png'
import moment from 'moment'
import MacroGraph from '../../average-graph/macro-graph'
import MacroAdjustmentGraph from './adjustment-graph'
import { editCheckWeighIn, editAddWeighIn } from "../../../../../../../api";
import iconWarning from '../../../../../../../images/coaching-messages/greenChart.png'

function validateWeight(weight, useMetric) {
  const inMetricRange = (weight <= 453.592 && weight >= 31.75)
  const inImperialRange = (weight <= 999 && weight >= 70)
  const isUsingMetric = (Number(useMetric) === 1)
  if (!(/^([0-9,.]{0,3})\d/.test(weight)) || ((isUsingMetric) ? !inMetricRange : !inImperialRange) || !weight || weight.length > 8)
    return 'Invalid weight'
}

function validateBodyFat(bodyFat, gender) {
  const inRangeMale = (Number(bodyFat) >= 3 && Number(bodyFat) <= 60)
  const inRangeFemale = (Number(bodyFat) >= 8 && Number(bodyFat) <= 65)

  if ((!inRangeMale && gender === 'MALE') || (!inRangeFemale && gender === 'FEMALE') || bodyFat.length > 5)
    return 'Invalid body fat percentage'
}

class EditCheckWeighInModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEdit: false,
      showEditAdd: false,
      showAddExplanation: false,
      weightId: '',
      bodyfatId: '',
      reportDate: '',
      weightError: '',
      editedWeightError: '',
      editedBfError: '',
      bodyFatError: '',
      showMenstrual: true,
      edit_showCompliant: true,
      edit_weight: '',
      edit_body_fat: '',
      edit_isCompliant: '',
      edit_isNearPeriod: '',
      edit_isRetainingFluid: '',
      edit_estimatedWeight: '',
      edit_shouldIgnoreWeightGain: '',
      edit_keep: null,
      edit_reasonCode: null,
      edit_reasonText: null,
      addExplanation: '',
      add_weight: '',
      add_estimatedWeight: '',
      add_body_fat: '',
      add_isCompliant: 0,
      add_isNearPeriod: '',
      add_isRetainingFluid: '',
      add_shouldIgnoreWeightGain: '',
      isSubmitting: false,
      showSnackbar: false
    }

    this.throttledResize = _.throttle(this.handleWindowSizeChange, 500);
  }

  componentDidMount() {
    window.addEventListener('resize', this.throttledResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledResize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(!_.isEmpty(this.props.weighins) && (this.props.open === false && nextProps.open === true)) {
      let avgProtein = 0
      let avgCarbs = 0
      let avgFat = 0
      
      if(nextProps.timeline.user !== undefined) {
        avgProtein = nextProps.timeline.user.avgProtein
        avgCarbs = nextProps.timeline.user.avgCarbs
        avgFat = nextProps.timeline.user.avgFat
      }
  
      let compareProtein = avgProtein < (Number(this.props.protein) + this.getProteinInterval(this.props.protein)) && avgProtein >= (this.props.protein - this.getProteinInterval(this.props.protein))
      let compareCarbs = avgCarbs < (Number(this.props.carbs) + this.getCarbsInterval(this.props.carbs)) && avgCarbs >= (this.props.carbs - this.getCarbsInterval(this.props.carbs))
      let compareFat = avgFat < (Number(this.props.fat) + this.getFatInterval(this.props.fat)) && avgFat >= (this.props.fat - this.getFatInterval(this.props.fat))
      this.checkIfCompliant(compareProtein, compareCarbs, compareFat)

      const weighin = nextProps.weighins[nextProps.selectedWeighInIndex]
      const showMenstrual = (this.props.gender === 'FEMALE' && this.props.skipNearPeriod !== 1)
      const prevWeighIn = nextProps.weighins[nextProps.selectedWeighInIndex + 1]
      const showCompliant = shouldShowCompliant(nextProps.startingPoint, weighin, prevWeighIn, nextProps.weighins, nextProps.selectedWeighInIndex)
      // const showEditEstimateWeight = shouldEstimateWeight('EditCheck', weighin)
      let estimatedWeight = null

      if(weighin.estimated_weight) {
        estimatedWeight = Math.round(((this.props.useMetricUnits) ? weighin.estimated_weight :  weighin.estimated_weight * LBS_PER_KG) * 10) / 10
      }

      this.setState({
        reportDate: weighin.report_date,
        weightId: weighin.weight_id,
        bodyfatId: weighin.bodyfat_id,
        showMenstrual: showMenstrual,
        edit_showCompliant: showCompliant,
        edit_weight: Math.round(((this.props.useMetricUnits) ? weighin.weight : weighin.weight * LBS_PER_KG) * 10) / 10,
        edit_body_fat: weighin.body_fat,
        edit_isCompliant: weighin.compliant,
        edit_estimatedWeight: estimatedWeight,
        edit_isNearPeriod: weighin.near_period,
        edit_isRetainingFluid: weighin.near_period,
        // showEditEstimateWeight: showEditEstimateWeight,
        edit_shouldIgnoreWeightGain: weighin.near_period,
        edit_keep: null,
        edit_reasonCode: null,
        edit_reasonText: null,
        addExplanation: '',
        add_weight: '',
        add_body_fat: '',
        add_isCompliant: 0,
        isSubmitting: false
      })
    }
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleReasonTextChange = (e) => {
    this.setState({edit_reasonText: e.target.value});
  }

  handleClear = () => {
    this.setState({ edit_keep: null, edit_reasonCode: null, edit_reasonText: null })
  }

  getEditBodyFat = (val) => {
    this.setState({ edit_body_fat: val})
  }

  getAddBodyFat = (val) => {
    this.setState({ add_body_fat: val})
  }

  getEffectiveNearPeriod = () => {
    return this.state.showMenstrual && this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && (this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1)
  }

  handleEditCheckSubmit = (e) => {
    const wError = validateWeight(this.state.edit_weight, this.props.useMetricUnits)
    const bfError = validateBodyFat(this.state.edit_body_fat, this.props.gender)
    const oldWeight = this.props.weighins[this.props.selectedWeighInIndex].weight
    let editedWeight = Number(this.state.edit_weight)
    let estimatedWeight = (this.state.edit_estimatedWeight) ? Number(this.state.edit_estimatedWeight) : null

    if(wError) {
      this.props.openFeedback('Invalid weight', true)
      return
    } else if (bfError) {
      this.props.openFeedback('Invalid body fat percentage', true)
      return
    } 

    // if(wError || bfError) {
    //   this.setState({ editedWeightError: wError, editedBfError: bfError })
    //   return
    // }

    if(!Number(this.props.useMetricUnits))
      editedWeight = editedWeight / LBS_PER_KG

    editedWeight = (Math.round(oldWeight * 100) / 100 === Math.round(editedWeight * 100) / 100) ? oldWeight : editedWeight

    const noEditEstimateWeight = (!this.state.edit_estimatedWeight && this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && (this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1))
    if(noEditEstimateWeight) {
      this.props.openFeedback('Please enter an estimated weight', true)
      // this.setState({ showSnackbar: true, response: 'Please enter an estimated weight.' })
      return
    }

    if(estimatedWeight && !Number(this.props.useMetricUnits))
      estimatedWeight = this.state.edit_estimatedWeight / LBS_PER_KG

    const request = {
      action: 'EditCheck',
      edits: {
        weight: editedWeight,
        body_fat: Number(this.state.edit_body_fat),
        weight_id: this.state.weightId,
        estimated_weight: estimatedWeight,
        bodyfat_id: this.state.bodyfatId,
        compliant: this.state.edit_isCompliant,
        report_date: this.props.weighins[this.props.selectedWeighInIndex].report_date.split('T')[0]
      },
      user_id: this.props.userId,
      portal_id: this.props.portalId
    }

    if(this.state.edit_showCompliant)
      request['edits']['compliant'] = this.state.edit_isCompliant

    const effectiveNearPeriod = this.getEffectiveNearPeriod()

    if(this.props.potentiallyKeepable) {
      let carryOverInfo = {keepable: false}
      if(this.state.edit_isCompliant) {
        carryOverInfo = getCarryOverInfo(request.edits.weight, request.edits.body_fat, effectiveNearPeriod, this.props.carryOverEnvironment, this.props.user)
      }
      if(!carryOverInfo.keepable) {
        if(this.props.weighins[this.props.selectedWeighInIndex].keep !== null) {
          request['edits']['adjustment_hidden'] = true
        }
      } else {
        if(this.state.edit_keep !== null && this.state.edit_keep !== this.props.keep) {
          request['edits']['keep'] = this.state.edit_keep
        }
        let reasonCode = this.state.edit_reasonCode === null ? this.props.reasonCode : this.state.edit_reasonCode
        const reasonText = this.state.edit_reasonText === null ? this.props.reasonText : this.state.edit_reasonText
        if(reasonCode !== this.props.reasonCode) {
          request['edits']['reason_code'] = reasonCode
        }
        if(reasonText !== this.props.reasonText) {
          request['edits']['reason_text'] = reasonText
        }
      }
    }

    if(this.state.showMenstrual)
      request['edits']['near_period'] = effectiveNearPeriod ? 1 : 0

    this.setState({ isSubmitting: true })
    
    if(this.props.editTodayCheckin) {
      request['action'] = 'Edit'
    }

    editCheckWeighIn(request).then((res) => {
      setTimeout(() => {
        this.setState({ showEdit: false, isSubmitting: false, edit_keep: null, edit_reasonCode: null, edit_reasonText: null })
        this.props.openFeedback('Recent check-in has been updated', false)
        this.props.loadPortalAccount();
        this.props.onClose();
      }, 1000)
    }).catch((err) => {
      if(err.response.data.response === 'Weigh-in required') {
        this.setState({ showEdit: false, showAddExplanation: true, addExplanation: err.response.data.paragraph1, isSubmitting: false })
      } else {
        this.props.openFeedback('Failed to edit check-in', true)
        this.setState({ isSubmitting: false })
      }
    })
  }

  handleRequestClose = () => {
      this.setState({ showSnackbar: false })
  }

  weightAndBFValidation = () => {
    const wError = validateWeight(this.state.add_weight, this.props.useMetricUnits)
    const wEditedError = validateWeight(this.state.edit_weight, this.props.useMetricUnits)
    const addEstWeightError = ((this.state.add_isCompliant !== 1 || this.state.add_shouldIgnoreWeightGain === 1) && this.state.add_estimatedWeight) ? validateWeight(this.state.add_estimatedWeight, this.props.useMetricUnits) : null
    const editEstWeightError = ((this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1) && this.state.edit_estimatedWeight) ? validateWeight(this.state.edit_estimatedWeight, this.props.useMetricUnits) : null
    const bfEditedError = validateBodyFat(this.state.edit_body_fat, this.props.gender)
    const bfError = validateBodyFat(this.state.add_body_fat, this.props.gender)

    return {
      wError,
      bfError,
      wEditedError,
      addEstWeightError,
      editEstWeightError,
      bfEditedError
    }
  }

  handleEditAddSubmit = (e) => {
    const editedWeight = Number((this.props.useMetricUnits) ? this.state.edit_weight : this.state.edit_weight / LBS_PER_KG)
    const oldWeight = this.props.weighins[this.props.selectedWeighInIndex].weight
    const errors = this.weightAndBFValidation()
    // const noEditEstimateWeight = (!this.state.edit_estimatedWeight && this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && (this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1) && this.state.showEditEstimateWeight)
    const noAddEstimateWeight = (!this.state.add_estimatedWeight && this.state.add_isNearPeriod === 1 && this.state.add_isRetainingFluid === 1 && (this.state.add_isCompliant !== 1 || this.state.add_shouldIgnoreWeightGain === 1))
    const { wError, bfError, addEstWeightError } = errors
    let addEstimatedWeight = null
    let editEstimatedWeight = null
    let editNearPeriod = 0
    let nearPeriod = 0

    if(wError) {
      this.props.openFeedback('Invalid weight', true)
      return
    } else if (bfError) {
      this.props.openFeedback('Invalid body fat percentage', true)
      return
    } else if (addEstWeightError) {
      this.props.openFeedback('Please enter an estimated weight', true)
      return
    }

    // if(wError || bfError || wEditedError || bfEditedError || editEstWeightError || addEstWeightError) {
    //   this.setState({
    //     weightError: wError,
    //     bfError: bfError,
    //     editedWeightError: wEditedError,
    //     editedBfError: bfEditedError,
    //     editEstWeightError: editEstWeightError,
    //     addEstWeightError: addEstWeightError
    //   })
    //   return
    // }

    if(noAddEstimateWeight) {
      this.props.openFeedback('Please enter an estimated weight', true)
      // this.setState({ showSnackbar: true, response: 'Please enter an estimated weight.' })
      return
    }

    if(this.state.edit_estimatedWeight && (this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1))
      editEstimatedWeight = Number((this.props.useMetricUnits) ? this.state.edit_estimatedWeight : this.state.edit_estimatedWeight / LBS_PER_KG)

    if(this.state.add_estimatedWeight && (this.state.add_isCompliant !== 1 || this.state.add_shouldIgnoreWeightGain === 1))
      addEstimatedWeight = Number((this.props.useMetricUnits) ? this.state.add_estimatedWeight : this.state.add_estimatedWeight / LBS_PER_KG)

    if(this.state.showMenstrual) {
      if(this.state.add_isNearPeriod === 1 && this.state.add_isRetainingFluid === 1 && (this.state.add_isCompliant !== 1 || this.state.add_shouldIgnoreWeightGain === 1))
        nearPeriod = 1
      if(this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && (this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1))
        editNearPeriod = 1
    }

    const request = {
      action:'EditAdd',
      add: {
        weight: (this.props.useMetricUnits) ? this.state.add_weight : this.state.add_weight / LBS_PER_KG,
        body_fat: this.state.add_body_fat,
        compliant: this.state.add_isCompliant,
        estimated_weight: addEstimatedWeight,
        report_date: toDateString(new Date())
      },
      edits: {
        weight: (Math.round(oldWeight * 100) / 100 === Math.round(editedWeight * 100) / 100) ? oldWeight : editedWeight,
        body_fat: Number(this.state.edit_body_fat),
        estimated_weight: editEstimatedWeight,
        weight_id: this.state.weightId,
        bodyfat_id: this.state.bodyfatId,
        compliant: this.state.edit_isCompliant,
        report_date: this.state.reportDate.split('T')[0]
      },
      user_id: this.props.userId,
      portal_id: this.props.portalId
    }

    if(this.state.edit_showCompliant)
      request['edits']['compliant'] = this.state.edit_isCompliant

    if(this.props.potentiallyKeepable) {
      let carryOverInfo = {keepable: false}
      if(this.state.edit_isCompliant) {
        carryOverInfo = getCarryOverInfo(request.edits.weight, request.edits.body_fat, editNearPeriod === 1, this.props.carryOverEnvironment, this.props.user)
      }
      if(!carryOverInfo.keepable) {
        if(this.props.weighins[this.props.selectedWeighInIndex].keep !== null) {
          request['edits']['adjustment_hidden'] = true
        }
      } else {
        if(this.state.edit_keep !== null && this.state.edit_keep !== this.props.keep) {
          request['edits']['keep'] = this.state.edit_keep
        }
        let reasonCode = this.state.edit_reasonCode === null ? this.props.reasonCode : this.state.edit_reasonCode
        const reasonText = this.state.edit_reasonText === null ? this.props.reasonText : this.state.edit_reasonText
        if(reasonCode !== this.props.reasonCode) {
          request['edits']['reason_code'] = reasonCode
        }
        if(reasonText !== this.props.reasonText) {
          request['edits']['reason_text'] = reasonText
        }
      }
    }

    if(this.state.showMenstrual) {
      request['edits']['near_period'] = editNearPeriod
      request['add']['near_period'] = nearPeriod
    }

    this.setState({ isSubmitting: true })
    editAddWeighIn(request).then((res) => {
      this.setState({ showEditAdd: false, isSubmitting: false})
      this.props.openFeedback('Recent check-in has been updated, and a new check-in was added', false)
      this.props.loadPortalAccount();
      this.props.onClose();
    }).catch((err) => {
      this.setState({ isSubmitting: false})
      this.props.openFeedback('Failed to edit/add check-in', true)
    })
  }

  handleClose = () => {
    this.props.showEditCheckWeighInModal(false, this.props.selectedWeighInIndex)
  }

  handleCloseEdit = () => {
    this.setState({ showEdit: false, edit_keep: null, edit_reasonCode: null, edit_reasonText: null })
  }

  handleCloseEditAdd = () => {
    this.setState({ showEditAdd: false })
  }

  renderCompliant = (mode) => {
    let avgProteinConsumed = 0
    let avgCarbsConsumed = 0
    let avgFatConsumed = 0
    let avgProteinTarget = 0
    let avgCarbsTarget = 0
    let avgFatTarget = 0
    
    const checkinDate = this.props.weighins[this.props.selectedWeighInIndex].report_date.split('T')[0]
    const checkinMacroData = this.props.macroData.weighInDetails[checkinDate].result

    if (checkinMacroData) {
      avgProteinConsumed = checkinMacroData.avgProtein.toFixed()
      avgCarbsConsumed = checkinMacroData.avgCarbs.toFixed()
      avgFatConsumed = checkinMacroData.avgFat.toFixed()
      avgProteinTarget = checkinMacroData.avgTargetProtein.toFixed()
      avgCarbsTarget = checkinMacroData.avgTargetCarbs.toFixed()
      avgFatTarget = checkinMacroData.avgTargetFat.toFixed()
    } else {
      this.props.getMacroData(checkinDate)
    }
    return (
      <>
        <h4 className="content-header">Tracked averages</h4>
        <label>Were you in range of your target macros since last check-in?</label>
        <MacroGraph
          proteinConsumed={Math.round(avgProteinConsumed)}
          carbsConsumed={Math.round(avgCarbsConsumed)}
          fatConsumed={Math.round(avgFatConsumed)}
          proteinTarget={Math.round(avgProteinTarget)}
          carbsTarget={Math.round(avgCarbsTarget)}
          fatTarget={Math.round(avgFatTarget)}
          vacationMode={this.props.user.vacation_mode}
          showConsumedMacros
          showUnderRange
          light
        />
        {(mode === 'edit') && (
          <div className='check-in-button-group'>
            <button className={(this.state.edit_isCompliant === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({edit_isCompliant: 1})}>Yes</button>
            <button className={(this.state.edit_isCompliant === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({edit_isCompliant: 0})}>No</button>
          </div>
        )}
      </>
    )
  }

  renderAdjustment = (carryOverInfo) => {
    const keep = this.state.edit_keep !== null ? this.state.edit_keep : this.props.keep
    const reasonCode = this.state.edit_reasonCode === null ? this.props.reasonCode : this.state.edit_reasonCode
    const reasonText = this.state.edit_reasonText === null ? this.props.reasonText : this.state.edit_reasonText
    const newProteinRounded = carryOverInfo.macros.new.protein
    const newCarbsRounded = carryOverInfo.macros.new.carbs
    const newFatRounded = carryOverInfo.macros.new.fat
    const oldProteinRounded = carryOverInfo.macros.old.protein
    const oldCarbsRounded = carryOverInfo.macros.old.carbs
    const oldFatRounded = carryOverInfo.macros.old.fat
    let carryOverQuestion = 'Would you like to accept your new macros or keep your old macros?'
    // carryOverQuestion += ' (' + newProteinRounded + 'g protein, ' + newCarbsRounded + 'g carbs, ' + newFatRounded + 'g fat, ' + (4 * (newProteinRounded + newCarbsRounded) + 9 * newFatRounded) + ' calories)'
    // carryOverQuestion += ', or keep your targets'
    // carryOverQuestion += ' (' + oldProteinRounded + 'g protein, ' + oldCarbsRounded + 'g carbs, ' + oldFatRounded + 'g fat, ' + (4 * (oldProteinRounded + oldCarbsRounded) + 9 * oldFatRounded) + ' calories)'
    // carryOverQuestion += ' for another week?'
    return (
      <>
        <h4 className="content-header">Macro Adjustment</h4>
        <label>{carryOverQuestion}</label>
        <MacroAdjustmentGraph 
          proteinValue={(keep === 1) ? oldProteinRounded : newProteinRounded}
          carbsValue={(keep === 1) ? oldCarbsRounded : newCarbsRounded}
          fatValue={(keep === 1) ? oldFatRounded : newFatRounded}
        />
        <div className='check-in-button-group'>
          <button className={(keep === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ edit_keep: 1 })}>Keep Targets</button>
          <button className={(keep === 0) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ edit_keep: 0 })}>Accept Adjustment</button>
        </div>
        {keep === 1 && this.props.user.skip_carry_over_reason === 0 &&
          <>
            <label>Okay. Why would you like to keep your targets? (you can select more than one reason)</label>
            <List>
              {getCarryOverReasons(this.props.weighins[this.props.selectedWeighInIndex].goal).map((reason, index) => (reason[0] & carryOverInfo.reasonsMask) !== 0 &&
                <ListItem key={reason[0]}>
                  <Icon className='material-icons' id={'carry-over-reason-checkbox-' + reason[0]} onClick={() => this.setState({edit_reasonCode: reasonCode ^ reason[0]})} style={{ color: (reasonCode & reason[0]) ? '#14ab40' : '#5a5a5a'}}>
                    {(reasonCode & reason[0]) ? 'check_circle' : 'radio_button_unchecked'}
                  </Icon>
                  <span className='carry-over-reason-text'>{reason[1]}</span>
                </ListItem>
              )}
            </List>
            <p className="carry-over-reason-label">Other (optional):</p>
            <textarea className="carry-over-reason-other" name="" value={reasonText} onChange={this.handleReasonTextChange}></textarea>
          </>
        }
        {/* <div className='weigh-in-question'>
          <div className='weigh-in-question-container'>
            <h3>ADJUSTMENT</h3>
            <p>{carryOverQuestion}</p>
            <div className='weigh-in-compliant-buttons'>
              <button className={(keep === 0) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ edit_keep: 0 })}>Accept Adjustment</button>
              <button className={(keep === 1) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ edit_keep: 1 })}>Keep Targets</button>
            </div>
          </div>
          {keep === 1 && this.props.user.skip_carry_over_reason === 0 &&
            <div className='carry-over-reason-container'>
              <p>Okay. Why would you like to keep your targets? (you can select more than one reason)</p>
              <List>
                {getCarryOverReasons(this.props.weighins[this.props.selectedWeighInIndex].goal).map((reason, index) => (reason[0] & carryOverInfo.reasonsMask) !== 0 &&
                  <ListItem key={reason[0]}>
                    <Icon className='material-icons' id={'carry-over-reason-checkbox-' + reason[0]} onClick={() => this.setState({edit_reasonCode: reasonCode ^ reason[0]})}>
                      {(reasonCode & reason[0]) ? 'check_box' : 'check_box_outline_blank'}
                    </Icon>
                    <span className='carry-over-reason-text'>{reason[1]}</span>
                  </ListItem>
                )}
              </List>
              <p>Other (optional):</p>
              <textarea className="carry-over-reason-other" name="" value={reasonText} onChange={this.handleReasonTextChange}></textarea>
            </div>
          }
        </div> */}
      </>
    )
  }

  renderMenstrual = (mode) => {
    return (mode === 'edit') ?
      <>
        <h4 className="content-header">Menstrual cycle</h4>
        <label>Are you within 5 days of starting your period?</label>
        {/* <p>{this.state.edit_isNearPeriod} {this.state.edit_isRetainingFluid} {(this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1) ? '1' : '0'} {this.state.showEditEstimateWeight ? '1' : '0'}</p> */}
        <div className='check-in-button-group'>
          <button className={(this.state.edit_isNearPeriod === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({edit_isNearPeriod: 1})}>Yes</button>
          <button className={(this.state.edit_isNearPeriod === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({edit_isNearPeriod: 0})}>No</button>
        </div>
        {(this.state.edit_isNearPeriod === 1) &&
          <>
            <label>Do you think that you may be retaining fluid weight?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.edit_isRetainingFluid === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ edit_isRetainingFluid: 1 })}>Yes</button>
              <button className={(this.state.edit_isRetainingFluid === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ edit_isRetainingFluid: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.edit_isCompliant === 1 && this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && this.props.goal !== 'REVERSE DIETING') &&
          <>
            <label>Since your menstrual cycle may be artificially increasing your weight this week, we will not adjust your macros if you fell short of your goal. Is this okay?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.edit_shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ edit_shouldIgnoreWeightGain: 1 })}>Yes</button>
              <button className={(this.state.edit_shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ edit_shouldIgnoreWeightGain: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.edit_isCompliant === 1 && this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && this.props.goal === 'REVERSE DIETING') &&
          <>
            <label>Since your menstrual cycle may be artificially increasing your weight this week, we will apply the typical adjustment to your macros even if you exceeded the limit defined by your goal. Is this okay?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.edit_shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ edit_shouldIgnoreWeightGain: 1 })}>Yes</button>
              <button className={(this.state.edit_shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ edit_shouldIgnoreWeightGain: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.edit_isNearPeriod === 1 && this.state.edit_isRetainingFluid === 1 && (this.state.edit_isCompliant !== 1 || this.state.edit_shouldIgnoreWeightGain === 1)) &&
          <>
            <label>Estimate your most recent weight that was not affected by your menstrual cycle:</label>
            <input name='edit_estimatedWeight' value={this.state.edit_estimatedWeight} onChange={this.handleChange}/>
            <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>
          </>
        }
      </>
    :
      <>
        <h4 className="content-header">Menstrual cycle</h4>
        <label>Are you within 5 days of starting your period?</label>
        <div className='check-in-button-group'>
          <button className={(this.state.add_isNearPeriod === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({add_isNearPeriod: 1})}>Yes</button>
          <button className={(this.state.add_isNearPeriod === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({add_isNearPeriod: 0})}>No</button>
        </div>
        {(this.state.add_isNearPeriod === 1) &&
          <>
            <label>Do you think that you may be retaining fluid weight?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.add_isRetainingFluid === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ add_isRetainingFluid: 1 })}>Yes</button>
              <button className={(this.state.add_isRetainingFluid === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ add_isRetainingFluid: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.add_isCompliant === 1 && this.state.add_isNearPeriod === 1 && this.state.add_isRetainingFluid === 1 && this.props.goal !== 'REVERSE DIETING') &&
          <>
            <label>Since your menstrual cycle may be artificially increasing your weight this week, we will not adjust your macros if you fell short of your goal. Is this okay?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.add_shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ add_shouldIgnoreWeightGain: 1 })}>Yes</button>
              <button className={(this.state.add_shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ add_shouldIgnoreWeightGain: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.add_isCompliant === 1 && this.state.add_isNearPeriod === 1 && this.state.add_isRetainingFluid === 1 && this.props.goal === 'REVERSE DIETING') &&
          <>
            <label>Since your menstrual cycle may be artificially increasing your weight this week, we will apply the typical adjustment to your macros even if you exceeded the limit defined by your goal. Is this okay?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.add_shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ add_shouldIgnoreWeightGain: 1 })}>Yes</button>
              <button className={(this.state.add_shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ add_shouldIgnoreWeightGain: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.add_isNearPeriod === 1 && this.state.add_isRetainingFluid === 1 && (this.state.add_isCompliant !== 1 || this.state.add_shouldIgnoreWeightGain === 1)) &&
          <>
            <label>Estimate your most recent weight that was not affected by your menstrual cycle:</label>
            <input name='add_estimatedWeight' value={this.state.add_estimatedWeight} onChange={this.handleChange}/>
            <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>
          </>
        }
      </>
  }

  checkIfCompliant = (compareProtein, compareFat, compareCarbs) => {
    if(compareProtein === true && compareFat === true && compareCarbs === true) {
      this.setState({ edit_isCompliant: 1 })
    }
  }

  getProteinInterval = (targetProtein) => {
    const proteinSlope = Math.round((1/30 * targetProtein) + (6.6666666667))
    if(targetProtein <= 100) {
      return 10
    }
    else if(targetProtein > 100 && targetProtein < 250) {
      return Math.round(proteinSlope)
    }
    else {
      return 15
    }
  }

  getCarbsInterval = (targetCarbs) => {
    const carbsSlope = Math.round((11/450 * targetCarbs) + (3.7777777778))
    if(targetCarbs <= 50) {
      return 5
    }
    else if(targetCarbs > 50 && targetCarbs < 500) {
      return Math.round(carbsSlope)
    }
    else {
      return 16
    }
  }

  getFatInterval = (targetFat) => {
    const fatSlope = Math.round((2/75 * targetFat) + (10/3))
    if(targetFat <= 75) {
      return 4
    }
    else if(targetFat > 75 && targetFat < 175) {
      return Math.round(fatSlope)
    }
    else {
      return 8
    }
  }

  getDisplayLabel = () => {
    return moment().calendar(null, {
      sameDay: '[Today], MMM Do',
      nextDay: '[Tomorrow], MMM Do',
      nextWeek: 'ddd, MMM Do',
      lastDay: '[Yesterday], MMM Do',
      lastWeek: 'ddd, MMM Do',
      sameElse: 'ddd, MMM Do',
    });
  }

  getWeightString = () => {
    if(this.props.user && this.props.dailyWeights) {
      const userProps = this.props.user
      const weights = this.props.dailyWeights
      let prevWeightStr,
        prevWeight,
        prevWeightLocal,
        units;
      units = userProps.use_metric_units === 0 ? 'Pounds' : 'Kg';
      if (weights.length) {
        prevWeight = weights[0].weight;
      } else {
        prevWeight = userProps.weight;
      }
      const multiplier = userProps.use_metric_units === 0 ? LBS_PER_KG : 1;
    
      if (prevWeight) {
        prevWeightLocal = Math.round(prevWeight * multiplier, 2);
        prevWeightStr = prevWeightLocal + ' ' + units;
      }
    
      return prevWeightStr;
    }
  };

  render() {
    const reportDate = new Date(this.state.reportDate)
    const reportDateFormatted = new Date((reportDate.getUTCFullYear()),reportDate.getMonth(),reportDate.getUTCDate()).toDateString()
    let carryOverInfo = {keepable: false}
    if(this.props.potentiallyKeepable && this.state.edit_isCompliant) {
      const wError = validateWeight(this.state.edit_weight, this.props.useMetricUnits)
      const bfError = validateBodyFat(this.state.edit_body_fat, this.props.gender)
      if(!(wError || bfError)) {
        const oldWeight = this.props.weighins[this.props.selectedWeighInIndex].weight
        let editedWeight = Number(this.state.edit_weight)

        if(!Number(this.props.useMetricUnits))
          editedWeight = editedWeight / LBS_PER_KG

        editedWeight = (Math.round(oldWeight * 100) / 100 === Math.round(editedWeight * 100) / 100) ? oldWeight : editedWeight

        const editedBodyFat = Number(this.state.edit_body_fat)
        carryOverInfo = getCarryOverInfo(editedWeight, editedBodyFat, this.getEffectiveNearPeriod(), this.props.carryOverEnvironment, this.props.user)
      }
    }

    return (
      <div>
        <Dialog 
          open={this.props.open}
          onClose={this.props.onClose}
          // open={this.props.showEditCheckModal} 
          // onClose={() => { this.setState({showEdit: true}); this.handleClose()}}
        >
          <DialogContent className='avn-modal-content-container'>
            <img src={iconWarning} alt="coaching-icon" />
            <h4>Warning</h4>
            <p>
              If you choose to edit this user's weight, body fat, or any other parameter
              associated with this check-in, this user's macro targets may change. Any
              major change to this user's existing macro targets will require a
              check in, as the system will need an accurate starting point
              to determine the effect of the new macros on this user's body. This will
              also push this user's next check-in back 7 days.
            </p>
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <AvatarButton className='avn-action-button'
              message='OK'
              onClick={this.props.onClose}
            />
          </DialogActions>
        </Dialog>
        
        <Dialog
          className='check-in-dialog' 
          fullScreen
          open={this.props.open}
          onClose={() => {this.props.onClose(); this.handleCloseEdit();}}
          // open={this.state.showEdit}
          // onClose={this.handleCloseEdit}
          autoScrollBodyContent={true}
        >
          <div className="check-in-close">
            <button onClick={() => {this.props.onClose(); this.handleCloseEdit();}}>
              <Icon>close</Icon>
            </button>
          </div>
          <div className="check-in-dialog">
            <div className="check-in-header">
              <h3>Edit Check-in</h3>
              <img src={Transition} alt="wave" />
            </div>
            <div className="check-in-content">
              <div className="check-in-date">
                <img src={IconCalendar} alt="calendar" />
                <p>{reportDateFormatted}</p>
              </div>

              <h4 className="content-header">Weight</h4>
              <label>Previous weight: <span style={{color: '#14ab40'}}>{this.getWeightString()}</span></label>
              <input name='edit_weight' type='number' value={this.state.edit_weight} onChange={this.handleChange}/>
              <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>

              <h4 className="content-header">Body fat percentage</h4>
              <label>Previous body fat percentage: <span style={{color: '#14ab40'}}>{this.props.user.body_fat}%</span></label>
              <input name='edit_body_fat' type='number' value={this.state.edit_body_fat} onChange={this.handleChange}/>

              {(this.state.edit_showCompliant) && this.renderCompliant('edit')}
              {(this.state.showMenstrual) && this.renderMenstrual('edit')}
              {carryOverInfo.keepable && this.renderAdjustment(carryOverInfo)}

              <button
                className="check-in-dialog-submit"
                onClick={this.handleEditCheckSubmit}
                disabled={this.state.submitDisabled}
              >
                Edit Check-in
              </button>
            </div>
          </div>
        </Dialog>



        <Dialog open={this.state.showAddExplanation} onClose={() => this.setState({showAddExplanation: false, showEditAdd: true})}>
          <DialogContent className='avn-modal-content-container'>
            <div className='avn-modal-header-container'>
              <h2>CHECK IN REQUIRED</h2>
            </div>
            <div className='avn-modal-header-dash'></div>
            <p>This user's macros have changed so we need a new starting point to see the effect they will have on their body. If you cancel, your recent changes will be lost.</p>
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <AvatarButton className='avn-action-button'
              message='Ok Check-in'
              onClick={() => this.setState({ showAddExplanation: false, showEditAdd: true })}
            />
          </DialogActions>
        </Dialog>

        <Dialog 
          className='check-in-dialog' 
          fullScreen
          // open
          open={this.state.showEditAdd} 
          onClose={this.handleCloseEditAdd} 
          onExited={this.handleClear}
        >
          <div className="check-in-close">
            <button onClick={this.handleCloseEditAdd}>
              <Icon>close</Icon>
            </button>
          </div>
          <div className="check-in-dialog">
            <div className="check-in-header">
              <h3>Check-in</h3>
              <img src={Transition} alt="wave" />
            </div>
            <div className="check-in-content">
              <div className="check-in-date">
                <img src={IconCalendar} alt="calendar" />
                <p>{this.getDisplayLabel()}</p>
              </div>

              <label>Note that your edits to the check-in for {moment.utc(this.state.reportDate).format('MMM D, YYYY')} will be discarded if you don't complete this check-in for today.</label>

              <h4 className="content-header">Weight</h4>
              <label>Previous weight: <span style={{color: '#14ab40'}}>{this.state.edit_weight} {this.props.useMetricUnits === 0 ? 'Pounds' : 'Kg'}</span></label>
              <input name='add_weight' type='number' value={this.state.add_weight} onChange={this.handleChange}/>
              <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>

              <h4 className="content-header">Body fat percentage</h4>
              <label>Previous body fat percentage: <span style={{color: '#14ab40'}}>{this.state.edit_body_fat}%</span></label>
              <input name='add_body_fat' type='number' value={this.state.add_body_fat} onChange={this.handleChange}/>

              {(this.state.add_showCompliant) && this.renderCompliant('add')}
              {(this.state.showMenstrual) && this.renderMenstrual('add')}

              <button
                className="check-in-dialog-submit"
                onClick={this.handleEditAddSubmit}
              >
                Check-in
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

// function mapStateToProps(state) {
//   let potentiallyKeepable = false
//   let carryOverEnvironment = null
//   let keep = 0
//   let reasonCode = 0
//   let reasonText = ''
//   if(state.user.weighins) {
//     if(state.dashboard.selectedWeighInIndex + 1 < state.user.weighins.length) {
//       const selectedWeighIn = state.user.weighins[state.dashboard.selectedWeighInIndex]
//       const previousWeighIn = state.user.weighins[state.dashboard.selectedWeighInIndex + 1]
//       carryOverEnvironment = getCarryOverEnvironment(selectedWeighIn, previousWeighIn)
//       potentiallyKeepable = carryOverEnvironment.potentiallyKeepable
//       if(potentiallyKeepable) {
//         if(selectedWeighIn.keep !== null) {
//           keep = selectedWeighIn.keep
//           reasonCode = selectedWeighIn.reason_code
//           reasonText = selectedWeighIn.reason_text
//         }
//       }
//     }
//   }
//   return {
//     userId: state.user.id,
//     weighins: state.user.weighins,
//     selectedWeighInIndex: state.dashboard.selectedWeighInIndex,
//     potentiallyKeepable: potentiallyKeepable,
//     carryOverEnvironment: carryOverEnvironment,
//     keep: keep,
//     reasonCode: reasonCode,
//     reasonText: reasonText,
//     gender: state.user.gender,
//     height: state.user.height,
//     skipNearPeriod: state.user.skip_near_period,
//     nearPeriod: state.user.near_period,
//     startingPoint: state.user.starting_point,
//     estimatedWeight: state.user.estimated_weight,
//     calories: state.user.calories,
//     protein: state.user.protein,
//     carbs: state.user.carbs,
//     fat: state.user.fat,
//     showEditCheckModal: state.dashboard.showEditCheckWeighInModal,
//     useMetricUnits: state.user.use_metric_units,
//     fullname: state.user.full_name,
//     timeline: state.timeline,
//     user: state.user,
//     dailyWeights: state.user.daily_weights,

//   }
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ showEditCheckWeighInModal, showModal, editCheckWeighIn, editAddWeighIn, openFeedback }, dispatch)
// }

// export default connect(mapStateToProps, mapDispatchToProps)(EditCheckWeighInModal)
export default EditCheckWeighInModal
